import { useUser } from '@folklore/auth';
import classNames from 'classnames';
import React, { useState } from 'react';

import * as AppPropTypes from '../../../lib/PropTypes';

import styles from '../../../../styles/themes/rhoneacademy/leaderboard-rhoneacademy.module.scss';

const propTypes = {
    page: AppPropTypes.page.isRequired,
};

const defaultProps = {};

function LeaderboardRhoneAcademy({ page }) {
    const { title: pageTitle = null, tables = [] } = page;
    const [currentTableIndex, setCurrentTableIndex] = useState(0);

    const { name: participantName = null, points: participantPoints = null } = useUser();

    const { items: currentItems = null, rank = null } = tables[currentTableIndex] || {};

    return (
        <div className={classNames(styles.container, 'noHeader')}>
            <div className={styles.header}>
                <div className={styles.main}>
                    <div className={styles.rank}>{rank !== null ? rank : '?'}</div>
                    <div className={styles.name}>{participantName}</div>
                </div>
                <div className={styles.stats}>
                    {/* <div className={styles.time}>
                        <span className={styles.clockIcon} />
                        <span>{sumfOfAnswerDurations}</span>
                    </div> */}
                    <div>{participantPoints} points</div>
                </div>
            </div>
            <div className={styles.tabs}>
                {tables.map(({ title = null }, index) => (
                    <button
                        type="button"
                        className={classNames(styles.tab, {
                            [styles.active]: index === currentTableIndex,
                        })}
                        onClick={() => setCurrentTableIndex(index)}
                    >
                        {title}
                    </button>
                ))}
            </div>
            <div className={styles.inner}>
                <h1>{pageTitle}</h1>
                <ul className={styles.leaderboard}>
                    {(currentItems || []).map(({ abbreviatedName, points, time }, index) => (
                        <li className={styles.item}>
                            <div className={styles.rank}>
                                {(index + 1).toString().padStart(2, '0')}
                            </div>
                            <div className={styles.name}>{abbreviatedName}</div>
                            <div className={styles.time}>
                                <span className={styles.clockIcon} />
                                <span>{time}</span>
                            </div>
                            <div className={styles.points}>{points} pts</div>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
LeaderboardRhoneAcademy.propTypes = propTypes;
LeaderboardRhoneAcademy.defaultProps = defaultProps;

export default LeaderboardRhoneAcademy;
